import PrivacyPolicyPage from "./privacyPolicyPage"

export default PrivacyPolicyPage;